<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Diagnóstico actual" class="mb-4"/>
		<title-bar v-if="school" :title="school.name" class="mb-4"/>
		<div class="col inner" v-if="synthesis" >
			<div style="width: 100%;">
				<div class="mb-4">
					<p>{{`Realizado el ${getHumanDateAndTime(synthesis.date)}`}}</p>
				</div>

				<div class="mb-4" v-if="!school">
					<h2>Colegio</h2>
					<p>{{synthesis.school.name}}</p>
				</div>

				<div class="mb-4">
					<h2>Coach</h2>
					<p>{{getPersonFullName(synthesis.coach)}}</p>
				</div>

				<div class="mb-4">
					<h2>Disciplina institucional</h2>
					<p class="font-weight-bold">Calificación: {{synthesis.data.institutionalDiscipline.value}}</p>
					<table class="table table-sm table-striped" v-if="synthesis.data.institutionalDiscipline.description">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.institutionalDiscipline.description" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Liderazgo efectivo</h2>
					<p class="font-weight-bold">Calificación: {{synthesis.data.effectiveLeadership.value}}</p>
					<table class="table table-sm table-striped" v-if="synthesis.data.effectiveLeadership.description">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.effectiveLeadership.description" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4" v-if="synthesis.data.teacherRotation">
					<h2>Rotación de profesores </h2>
					<template v-if="synthesis.data.teacherRotation.length > 0">
						<table class="table table-sm table-striped border border-light mb-4" v-for="(item, index) in synthesis.data.teacherRotation" :key="`teacherRotation${index}`">
							<tr>
								<td colspan="2">
									<p class="text-justify font-weight-bold">{{item.academicLevel.name}} / {{item.language.name}}</p>
									<p v-if="!item.description" class="text-justify">Sin registro</p>
									<b-form-textarea v-else class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="item.description" :disabled="true"/>
								</td>
							</tr>
							<tr>
								<td><p class="text-justify">Cantidad de profesores:</p></td>
								<td><p class="text-right">{{item.teacherAmount}}</p></td>
							</tr>
							<tr>
								<td><p class="text-justify">Profesores nuevos:</p></td>
								<td><p class="text-right">{{item.newTeachers}}</p></td>
							</tr>
						</table>
					</template>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Rotación directiva: {{synthesis.data.directorRotation.rotation ? 'Si' : 'No'}}</h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.directorRotation.description">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.directorRotation.description" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Expectativas del colegio hacia la metodología</h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.yearExpectations">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.yearExpectations" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Aliado(s) interno(s)</h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.internalAllies">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.internalAllies" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Factor de riesgo actual que pone en peligro la continuidad</h2>
					<p class="font-weight-bold" v-if="synthesis.data.riskFactorText">Factor: {{synthesis.data.riskFactorText}}</p>
					<table class="table table-sm table-striped" v-if="synthesis.data.currentRiskFactor">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.currentRiskFactor" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Estrategias o acciones que aseguren la continuidad</h2>
					<p class="font-weight-bold" v-if="synthesis.data.strategyFactorText">Factor: {{synthesis.data.strategyFactorText}}</p>
					<table class="table table-sm table-striped" v-if="synthesis.data.interventionStrategy">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.interventionStrategy" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Posible crecimiento</h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.possibleGrowth">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="synthesis.data.possibleGrowth" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['synthesisId', 'schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		synthesis () {
			if (!this.$store.state.admin.synthesis) return null;
			let synthesis = this.$store.state.admin.synthesis;
			let type = typeof synthesis.data;
			if (type !== 'object') synthesis.data = JSON.parse(synthesis.data);
			if (synthesis.data.strategyFactor) {
				let strategyFactor = this.getStrategyFactor(synthesis.data.strategyFactor);
				synthesis.data.strategyFactorText = strategyFactor.text;
			}
			if (synthesis.data.riskFactor) {
				let riskFactor = this.getRiskFactor(synthesis.data.riskFactor);
				synthesis.data.riskFactorText = riskFactor.text;
			}
			return synthesis;
		},
		school () {
			if (!this.$store.state.admin.schools) return null;
			if (!this.schoolId) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		},
		riskFactorDropdown () {
			return this.$store.getters.riskFactorDropdown;
		},
		strategyFactorDropdown () {
			return this.$store.getters.strategyFactorDropdown;
		}
	},
	methods: {
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		getRiskFactor (factor) {
			return this.riskFactorDropdown.find((item) => (item.value == factor));
		},
		getStrategyFactor (factor) {
			return this.strategyFactorDropdown.find((item) => (item.value == factor));
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/DiagnosticDetail.vue